module.exports = __webpack_public_path__ + "static/media/skclhat.81d61bdf.wav";